/*
 * 消息存档首页 - 右侧 - 图片组件
 * @Author: pwq
 * @Date: 2020-2-18
 * @Last Modified by: pwq
 */
import React, { useEffect, useState } from "react";
import api from '@/apis/pc/conversation/conversation'
import styled from 'styled-components'
import Zmage from 'react-zmage'
import InfiniteScroll from 'react-infinite-scroll-component';
import PlayIcon from '@/img/play.png';
import { checkImgWidth } from '@/utils/utils'

const Wrapper = styled.div`
  border-top: 1px solid #E9E9E9;
  padding-top: 16px;
  height: 94%;
`
const Time = styled.div`
  font-size: 12px;
  color: #BFBFBF;
  text-align: center;
  padding-bottom: 8px;
  text-align: center;
  width: 100%;
`
const ImgContent = styled.div`
  width: 296px;
  margin-left: 12px;
  padding-bottom: 12px;
  img {
    width: 50px;
    height: 50px;
    margin: 0 0 4px 6px;
    object-fit: cover;
  }
`
const NoData = styled.div`
  color: #BFBFBF;
  text-align: center;
  margin-top: 40px;
`
const VideoWrapper = styled.div`
  display: flex;
  position: relative;
  video {
    width: 50px;
    height: 50px;
    object-fit: cover;
  }
`
const PlayImg = styled.img`
  width: 20px !important;
  height: 20px !important;
  margin: 0 !important;
  border-radius: 50%;
  position: absolute;
  top: 14px;
  left: 14px;
  object-fit: cover;
`

const Picture = (props) => {
  const { session } = props;
  const [pageInfo, setPageInfo] = useState({ pageSize: 50, pageType: 1 });
  const [hasMore, setHasMore] = useState(true); // 是否有下一页
  const [list, setList] = useState([]); // 图片信息List

  useEffect(() => {
    getChatMessage();
  }, [pageInfo])

  const getChatMessage = () => {
    if (!session.sessionId) return;
    let params = {
      sessionId: session.sessionId,
      messageType: 3,
      ...pageInfo
    }
    api.chatSearch(params).then(response => {
      if (response.code === 0) {
        let listArr = list.concat(response.data.list);
        listArr.map(item => {
          if (typeof (item.messageContent) === 'string') {
            item.messageContent = JSON.parse(item.messageContent);
          }
        })
        setHasMore(response.data.nextPage)
        setList(listArr);
      }
    })
  }

  const RenderImgMsg = (props) => {
    const { url } = props
    const [imgWidth, setImgWidth] = useState(255)
    const [imgHeight, setImgHeight] = useState(255)
    checkImgWidth(url).then(({ width, height }) => {
      const maxWidth = 255
      const maxHeight = 255
      if (width >= height && width >= maxHeight) {
        setImgWidth(maxWidth)
        setImgHeight(maxWidth * height / width)
      }
      if (height > width && height >= maxHeight) {
        setImgHeight(maxHeight)
        setImgWidth(maxHeight * width / height)
      }
    })

    return (
      <Zmage src={url} width={imgWidth} height={imgHeight} alt='图片' defaultPage={0}
        controller={{ close: true, zoom: false, download: false, rotate: false }}
        set={[{
          src: url, alt: "图片",
          style: {
            position: "fixed",
            top: `calc(50% - ${imgHeight}px)`,
            left: `calc(50% - ${imgWidth}px)`,
            width: imgWidth * 2,
            height: imgHeight * 2,
          }
        }]} />
    )
  }

  const renderInfo = (type, url) => {
    switch (type) {
      case 1:
      case 4:
        return <RenderImgMsg url={url} />
      case 3:
        return <VideoWrapper><video src={url} /><PlayImg src={PlayIcon} /></VideoWrapper>
    }
  }
  // 下拉加载
  const handleScroll = (lastMessageId) => {
    pageInfo.lastMessageId = lastMessageId
    pageInfo.pageType = 3
    setPageInfo({ ...pageInfo });
  }
  return (
    <Wrapper>
      <InfiniteScroll
        dataLength={list.length}
        next={() => handleScroll(list[list.length - 1].id)}
        height={660}
        hasMore={hasMore}
      >
        {list.length > 0 ? list.map(item => (
          <div key={item.id}>
            <Time>{item.msgTimeStr}</Time>
            <ImgContent>
              {renderInfo(item.messageContent?.fileType, item?.messageContent?.url)}
            </ImgContent>
          </div>
        )) : <NoData>暂无数据</NoData>}
      </InfiniteScroll>
    </Wrapper>
  )
}

export default Picture
